import {
  IForEachSchemaOptions,
  Schema,
  forEachSchemaNode,
  yup,
} from '@framework/validation';
import { BurdenWidgetMetaKeys } from './createBurdenWidgetFormSchema';

export interface IComputedBurden {
  widgetId: string;
  path: string | undefined;
  macroBurdenTypeId: string;
  value: string | null | undefined;
}

/**
 * Estrae tutti gli oneri presenti in uno Schema di una Richiesta.
 */
export function findBurdensInSchema(
  schema: yup.ISchema<any>,
  options: IForEachSchemaOptions,
): IComputedBurden[] {
  const burdens: IComputedBurden[] = [];

  forEachSchemaNode(schema, options, node => {
    if (
      node.schema instanceof Schema &&
      node.schema.meta?.()?.[BurdenWidgetMetaKeys.WidgetId] &&
      !node.schema.spec.strip
    ) {
      const widgetId = node.schema.meta?.()?.[BurdenWidgetMetaKeys.WidgetId];
      const macroBurdenTypeId =
        node.schema.meta?.()?.[BurdenWidgetMetaKeys.MacroBurdenTypeId];

      if (!widgetId || !macroBurdenTypeId) {
        console.warn(`Missing widgetId or macroBurdenTypeId in schema ${node.path}`, { node }); // prettier-ignore
        return;
      }

      burdens.push({
        widgetId,
        path: node.path,
        macroBurdenTypeId,
        value: node.value?.toString(),
      });
    }
  });

  return burdens;
}
